/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_IndustrialInputs */

const en_val_industrial = /** @type {(inputs: Val_IndustrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industrial`)
};

const es_val_industrial = /** @type {(inputs: Val_IndustrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industrial`)
};

const fr_val_industrial = /** @type {(inputs: Val_IndustrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industriel`)
};

const de_val_industrial = /** @type {(inputs: Val_IndustrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industriell`)
};

const ja_val_industrial = /** @type {(inputs: Val_IndustrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工業用`)
};

const zh_val_industrial = /** @type {(inputs: Val_IndustrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工业`)
};

const ar_val_industrial = /** @type {(inputs: Val_IndustrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صناعي`)
};

const id_val_industrial = /** @type {(inputs: Val_IndustrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industri`)
};

const it_val_industrial = /** @type {(inputs: Val_IndustrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industriale`)
};

const ru_val_industrial = /** @type {(inputs: Val_IndustrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промышленная недвижимость`)
};

const pt_val_industrial = /** @type {(inputs: Val_IndustrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industrial`)
};

const ko_val_industrial = /** @type {(inputs: Val_IndustrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`산업용`)
};

/**
* | output |
* | --- |
* | "Industrial" |
*
* @param {Val_IndustrialInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_industrial = /** @type {((inputs?: Val_IndustrialInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_IndustrialInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_industrial(inputs)
	if (locale === "es") return es_val_industrial(inputs)
	if (locale === "fr") return fr_val_industrial(inputs)
	if (locale === "de") return de_val_industrial(inputs)
	if (locale === "ja") return ja_val_industrial(inputs)
	if (locale === "zh") return zh_val_industrial(inputs)
	if (locale === "ar") return ar_val_industrial(inputs)
	if (locale === "id") return id_val_industrial(inputs)
	if (locale === "it") return it_val_industrial(inputs)
	if (locale === "ru") return ru_val_industrial(inputs)
	if (locale === "pt") return pt_val_industrial(inputs)
	return ko_val_industrial(inputs)
});